import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import auth from './auth/reducer';
import user from './user/reducer';
import employee from './employee/reducer';
import deals from './deals/reducer';
import logins from './logins/reducer';
import sourceMappings from './sourceMappings/reducer';
import forms from './forms/reducer';
import formPacks from './formPacks/reducer';
import pencils from './pencils/reducer';
import desking from './desking/reducer';
import deskingPayments from './deskingPayments/reducer';
import dealers from './dealers/reducer';
import feeds from './feeds/reducer';
import pen from './pen/reducer';
import feedMappings from './feedMappings/reducer';
import feedviews from './feedviews/reducer';
import websites from './websites/reducer';
import roles from './roles/reducer';
import announcements from './announcements/reducer';
import global from './global/reducer';
import permissions from './permissions/reducer';
import widgets from './widgets/reducer';
import fonts from './fonts/reducer';
import verifications from './verifications/reducer';
import analytics from './analytics/reducer';
import dealerDataRevisions from './dealerDataRevisions/reducer';
import cars from './cars/reducer';
import translations from './translations/reducer';
import translationRules from './translationRules/reducer';
import accessories from './accessories/reducer';
import groups from './groups/reducer';
import outreachForms from './outreachForms/reducer';
import appConfigurations from './appConfigurations/reducer';
import dtEntities from './dtEntities/reducer';
import tekionEntities from './tekionEntities/reducer';
import pencilHistory from './pencilHistory/reducer';

const createRootReducer = history =>
  combineReducers({
    auth,
    user,
    employee,
    deals,
    logins,
    sourceMappings,
    dealers,
    groups,
    feeds,
    feedMappings,
    feedviews,
    websites,
    roles,
    fonts,
    announcements,
    forms,
    formPacks,
    pencils,
    desking,
    deskingPayments,
    global,
    pen,
    router: connectRouter(history),
    permissions,
    widgets,
    verifications,
    analytics,
    dealerDataRevisions,
    cars,
    translations,
    translationRules,
    accessories,
    outreachForms,
    appConfigurations,
    dtEntities,
    tekionEntities,
    pencilHistory,
  });

export default createRootReducer;
